import React, { Component } from "react";
class NLSReportRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render() {
        const { email, fullName, orderDate, orderStatus, phone, userName, orderId } = this.props;
        return (
            <div className="table_row user_page user_data main_data">
                {email ?
                    (<div onClick={this.props.toggle_order_details_popup}>
                        <div>{userName}</div>
                        <div>{fullName}</div>
                        <div>{email}</div>
                        <div>{phone}</div>
                        <div>{orderDate}</div>
                        {orderStatus.toLowerCase() !== 'success' ? <div className="orderstatus"><span>{orderId === '-' || orderId === '' ? 'Failed' : orderStatus}</span></div> : <div className="orderstatussuccess"><span>{orderStatus}</span></div>}</div>)
                    : (
                        <div>
                            <div className="no_record_found">No Record Found</div>
                        </div>
                    )}

            </div>

        );
    }
}

export default NLSReportRow;